<template>
    <section class="view spacer">
        <vue-headful
            title="Facilities View | What goes into a Facilities View"
            description="Calculate total cost of operation and maintenance of all property holdings and leases. Compare against relevant benchmarks and assess utility and cost saving opportunities."
            url="https://www.fedsight.com/facilities-view"
        />
        <section class='container-fluid d-flex align-items-center justify-content-center'>
        </section>

        <section class='viewIntro'>
            <div class='container'>
                <h1 class='viewHeader fedsightBlue'>FACILITIES VIEW</h1> 
                <p class='viewMainParagraph'>
                    Facilities View provides comprehensive visibility into your organization's entire facilities portfolio with reports and models related to costs, use and utilization, comparative analysis, trends, forecasts, and scenarios. Examine facilities as a portfolio or by function, organization, and program. Sophisticated forecasting and scenario analysis models and the ability to compare and contrast different courses of action support more complex analysis efforts. Facilities managers and analysts are able to respond to data calls, produce executive reports, and conduct in-depth analysis with incredible ease.
                </p>
            </div>
            
        </section>

        <section class='blogPost'>
            <div class='container blogPostContainer'>
                <h2 class='fedsightBlue' style='margin-top: 0rem;'>
                    Key Business Questions:
                </h2>
                <ul>
                    <li>
                        What are the costs for both GSA leased, direct leased, and owned real estate for your organization and what they will be in the future?
                    </li>
                    <li>
                        What are the total costs and historical trends for real estate by organization, support function, and program? Is the real estate footprint optimized to meet mission and other requirements?
                    </li>
                    <li>
                        What are the trends for facilities costs related to leases, O&M, building & repair, utilities, and facilities management?
                    </li>
                    <li>
                        What is the human capital footprint (employees and contractors) at each facility? What are the functions and costs of human capital vs. cost of real estate? Do opportunities exist to optimize real estate in terms of use, location, cost, etc.?
                    </li>
                    <li>
                        To what extent do facilities management contracts and systems overlap organizationally, programmatically, or geographically for similar products and services?
                    </li>
                    <li>
                        Are you getting the the best rates from facilities management vendors? What are other organizations paying for similar contracts?
                    </li>
                    <li>
                        How does your organization spend on certain facilities products or services compared to what other organizations are paying?
                    </li>
                </ul>
            </div>

            <div class='container blogPostContainer'>
                <h2 class='fedsightBlue' style='margin-top: 0rem;'>
                    Who we are
                </h2>
                <p>
                    Fedsight Consulting is an SBA certified HUBZone small business consulting firm focused on helping organizations improve operations and program performance. Our strategic, financial, and operational support services provide insight and perspective on program performance and operational trends.  Fedsight Consulting’s subject matter expertise, methods, and tools enable federal organizations to accomplish objectives, effectively manage resources, and improve program performance.
                </p>
                <p>
                    To learn more about Fedsight Consulting and discuss potential opportunities, email <span class='emailLink' @click='emailUs()'>info@fedsight.com</span>.
                </p>
            </div>
        </section>

        <Footer />
  </section>
</template>

<script>
import Footer from '@/components/Footer.vue'
import closeMenu from '../../mixins/closeMenu'


export default {
    name: 'facilities-view',
    components: {
        Footer
    },
    metaInfo: {
      link: [
        {rel:'canonical', href:'https://www.fedsight.com/facilities-view'}
      ]
    },
    mixins: [closeMenu],
    methods: {
      emailUs(){
          window.location.href = "mailto:info@fedsight.com?subject=I%20would%20like%20to%20learn%20more%20about%20Fedsight&body=Hello,%0D%0A%0D%0APlease%20contact%20me%20to%20discuss%20how%20Fedsight%20can%20assist%20my%20company.%0D%0A%0D%0A";
      }
    },
    mounted() {
        document.dispatchEvent(new Event('page.rendered'));
    }
}
</script>

<style scoped>
.viewIntro{
    padding: 8rem 0rem 2rem;
    max-width: 100rem;
    margin: auto;
    text-align: left;
}
.viewHeader{
    font-size: 4rem;
    font-weight: bold;
    text-align: center;
    /*background-color: #132631;
    color: #fff; */
    width: 100%;
    padding: 2rem 0rem;
}
.blogPost{
    text-align: left;
}
.blogPostContainer{
    max-width: 100rem;
    margin: 3rem auto;
}
.viewHero{
    height: 30rem;
}
.viewHeader{
    color: #fff;
    font-size: 6rem;
}
.emailLink{
    color: #007bff;
    cursor: pointer;
}
.emailLink:hover{
    color: #0056b3;
    text-decoration: underline;
}
h2{
    margin-top: 3rem;
}


/* Small devices (landscape phones, 576px and up) */
  @media (max-width: 576px) { 
    .slogan {
      font-size: 3.5rem !important;
    }
  }

  @media (max-width: 768px) { 
    .slogan{
      text-align: center;
      margin-left: auto;
      margin-right: auto;
    }
  }

  @media (max-width: 992px){
    .container{
        padding: 1.5rem !important;
    }
  }

  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) { 
    
    .slogan {
      font-size: 9rem !important;
    }
  }
</style>